// third-party
import { FormattedMessage } from 'react-intl';
import { ProjectOutlined } from '@ant-design/icons';

// icons
const icons = { ProjectOutlined };

// ==============================|| MENU ITEMS - PROJETOS ||============================== //

const projetos = {
  id: 'Projetos',
  title: <FormattedMessage id="Projetos" />,
  type: 'group',
  children: [
    {
      id: 'Projetos',
      title: <FormattedMessage id="Projetos" />,
      type: 'collapse',
      icon: icons.ProjectOutlined,
      children: [
        {
          id: '345568766',
          title: <FormattedMessage id="Projetos" />,
          type: 'item',
          url: '/engagement/projetos/lista',
        },
        {
          id: '345568767',
          title: <FormattedMessage id="Programação" />,
          type: 'item',
          url: '/engagement/programacoes/lista',
        },
      ]
    },
  ]
};

export default projetos;
